import { Injectable } from '@angular/core';

/**
 * Allow changing the window title and favicon.
 *
 * @export
 */
@Injectable({
    providedIn: 'root',
})
export class WindowTitleService {
    private _defaultDashboardTitle: string;
    private _defaultDashboardFavicon: string;

    private get titleElement(): HTMLTitleElement {
        let titleElement = document.getElementById('dashboard-title') as HTMLTitleElement;

        if (!titleElement) {
            const titleResults = document.getElementsByTagName('title');

            if (titleResults.length === 0) {
                return undefined;
            }

            titleElement = titleResults[0];
        }

        return titleElement;
    }

    private get faviconElement(): HTMLLinkElement {
        let faviconElement = document.getElementById('dashboard-favicon') as HTMLLinkElement;

        if (!faviconElement) {
            const linkResults = document.getElementsByTagName('link');

            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < linkResults.length; i++) {
                if (linkResults[i].rel === 'icon') {
                    faviconElement = linkResults[i];
                    break;
                }
            }
        }

        return faviconElement;
    }

    get defaultDashboardTitle(): string {
        return this._defaultDashboardTitle;
    }

    get defaultDashboardFavicon(): string {
        return this._defaultDashboardFavicon;
    }

    get dashboardTitle(): string {
        return this.titleElement.innerText;
    }

    set dashboardTitle(value: string) {
        this.titleElement.innerText = value;
    }

    get dashboardFavicon(): string {
        return this.faviconElement.href;
    }

    set dashboardFavicon(value: string) {
        this.faviconElement.href = value;
    }

    constructor() {
        this._defaultDashboardTitle = this.dashboardTitle;
        this._defaultDashboardFavicon = this.dashboardFavicon;
    }

    /** Set the window title and favicon to the default value  */
    resetDefault(): void {
        this.titleElement.innerHTML = this._defaultDashboardTitle;
        this.faviconElement.href = this._defaultDashboardFavicon;
    }
}
